

const checkCon = () => ({
  type: 'CHECKING_CONNECTION'
})

export const checkConnection = () => (dispatch) => {
  dispatch( checkCon() );
}



/** WEBPACK FOOTER **
 ** ./src/actions/global.actions.js
 **/